import React from "react";
import AdvancedActions from "./../AdvancedActions";

const MenuOptionStep = ({
  chatbotOption,
  setChatbotOption,
  errors,
  customerColumns,
  chatbot
}) => {
  return (
    <AdvancedActions
      chatbot={chatbot}
      chatbotOption={chatbotOption}
      setChatbotOption={setChatbotOption}
      customerColumns={customerColumns}
      errors={errors}
    />
  )
}

export default MenuOptionStep;